import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Button, ButtonToolbar, Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import GenericSelection from '../Common/GenericSelection';
import DoubleClickRenderer from '../Common/rowRenderer';
import SpinnerButton from '../Common/SpinnerButton';
import { fetchAllDrivers } from '../../actions/dispatch_actions';
import { isLE } from '../../actions/root_url';
const {
  Draggable: { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer },
  Data: { Selectors },
} = require('react-data-grid-addons');

const RowRenderer = DropTargetRowContainer(DoubleClickRenderer);

class EditRouteModal extends Component {
  static getDayOptions() {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const dayOptions = [];
    days.map((day) => {
      dayOptions.push({ value: day, label: day });
    });
    return dayOptions;
  }
  constructor(props) {
    super(props);

    this.state = {
      sourceCustomers: {
        rows: [],
        selectedRows: [],
      },
      destCustomers: {
        rows: [],
        selectedRows: [],
      },
      routes: [],
      drivers: [],
      selectedRoute: '',
      selectedDriver: '',
      selectedDay: '',
      selectedCustomer: '',
      selectedAllRoutes: '',
      sourceStopDay: '',
      sourceRouteDay: '',
      destStopDay: '',
      destRouteDay: '',
      cellSelected: '',
      email: '',
    };

    this.setSelectedRoute = this.setSelectedRoute.bind(this);
    this.setSelectedDriver = this.setSelectedDriver.bind(this);
    this.setSelectedDay = this.setSelectedDay.bind(this);
    this.setSelectedCustomer = this.setSelectedCustomer.bind(this);
    this.setSelectedAllRoutes = this.setSelectedAllRoutes.bind(this);
    this.removeSourceRow = this.removeSourceRow.bind(this);
    this.removeDestRow = this.removeDestRow.bind(this);
    this.moveLeftToRight = this.moveLeftToRight.bind(this);
    this.moveRightToLeft = this.moveRightToLeft.bind(this);
  }

  componentDidMount() {
    this.handleFetchDrivers();
    this.setState({
      email: this.props.selectedRoute ? this.props.selectedRoute.email : '',
    })
    this.setDayAndRoute();
    this.props.fetchAllRoutes();
  }

  setSelectedDay(e) {
    let routeLetter;
    const routes = [];
    if (e.value === 'Monday') {
      routeLetter = 'A';
    } else if (e.value === 'Tuesday') {
      routeLetter = 'B';
    } else if (e.value === 'Wednesday') {
      routeLetter = 'C';
    } else if (e.value === 'Thursday') {
      routeLetter = 'D';
    } else if (e.value === 'Friday') {
      routeLetter = 'E';
    } else if (e.value === 'Saturday') {
      routeLetter = 'F';
    } else if (e.value === 'Sunday') {
      routeLetter = 'G';
    }
    this.props.allRoutes.map((route) => {
      if (route.RouteNum.includes(routeLetter)) {
        routes.push([route.RouteNum, route.Email, route.driver_id]);
      }
    });
    this.setState({
      selectedDay: e.value,
      selectedRoute: '',
      selectedDriver: '',
      selectedAllRoutes: '',
      sourceCustomers: {},
      destCustomers: {},
      routes,
    });
  }

  setSelectedRoute(e) {
    if (isLE) {
      const success = (id) => {
        let rows = this.props.customersWithStops.rows.filter(obj => obj.dispatchRouteIds.includes(id));
        const sourceCustomers = { ...this.state.sourceCustomers, rows };
        this.setState({
          sourceCustomers,
        })
      }
      this.props.fetchSelectedRouteDispatchId(this.state.selectedDay, e.value, success);
      this.setState({
        selectedRoute: e,
        selectedAllRoutes: '',
        selectedDriver: e.driver || '',
        destCustomers: {},
        email: e.email || '',
      });
      return;
    }
    let sourceRouteDay;
    let sourceStopDay;
    switch (e.value.slice(0, 1)) {
      case 'A':
        sourceRouteDay = 'MonRoute';
        sourceStopDay = 'MonStop';
        break;
      case 'B':
        sourceRouteDay = 'TuesRoute';
        sourceStopDay = 'TuesStop';
        break;
      case 'C':
        sourceRouteDay = 'WedRoute';
        sourceStopDay = 'WedStop';
        break;
      case 'D':
        sourceRouteDay = 'ThursRoute';
        sourceStopDay = 'ThursStop';
        break;
      case 'E':
        sourceRouteDay = 'FriRoute';
        sourceStopDay = 'FriStop';
        break;
      case 'F':
        sourceRouteDay = 'SatRoute';
        sourceStopDay = 'SatStop';
        break;
      case 'G':
        sourceRouteDay = 'SundayRoute';
        sourceStopDay = 'SundayRoute';
        break;
      default:
        return;
    }
    let rows = this.props.customersWithStops.rows.filter(obj => obj[sourceRouteDay] === e.value);
    rows = _.sortBy(rows, key => key[sourceStopDay]);
    rows.map((row, index) => {
      row[sourceStopDay] = index + 1;
    });
    const sourceCustomers = { ...this.state.sourceCustomers, rows };
    this.setState({
      selectedRoute: e,
      sourceCustomers,
      sourceStopDay,
      sourceRouteDay,
      selectedAllRoutes: '',
      selectedDriver: e.driver || '',
      destCustomers: {},
      email: e.email || '',
    });
  }

  setSelectedCustomer(e) {
    this.setState({ selectedCustomer: e });
  }

  setSelectedDriver(e) {
    this.setState({ selectedDriver: e });
  }

  setSelectedAllRoutes(e) {
    let destRouteDay;
    let destStopDay;
    switch (e.value.slice(0, 1)) {
      case 'A':
        destRouteDay = 'MonRoute';
        destStopDay = 'MonStop';
        break;
      case 'B':
        destRouteDay = 'TuesRoute';
        destStopDay = 'TuesStop';
        break;
      case 'C':
        destRouteDay = 'WedRoute';
        destStopDay = 'WedStop';
        break;
      case 'D':
        destRouteDay = 'ThursRoute';
        destStopDay = 'ThursStop';
        break;
      case 'E':
        destRouteDay = 'FriRoute';
        destStopDay = 'FriStop';
        break;
      case 'F':
        destRouteDay = 'SatRoute';
        destStopDay = 'SatStop';
        break;
      case 'G':
        destRouteDay = 'SundayRoute';
        destStopDay = 'SundayRoute';
        break;
      default:
        return;
    }
    let rows = this.props.customersWithStops.rows.filter(obj => obj[destRouteDay] === e.value);
    rows = _.sortBy(rows, key => key[destStopDay]);
    const destCustomers = { ...this.state.destCustomers, rows };
    rows.map((row, index) => {
      row[destStopDay] = index + 1;
    });
    this.setState({
      selectedAllRoutes: e, destCustomers, destStopDay, destRouteDay,
    });
  }

  setDayAndRoute() {
    const selectedDay = (this.props.selectedDay) ? this.props.selectedDay : '';
    const selectedRoute = (this.props.selectedRoute) ? this.props.selectedRoute : '';
    const selectedCustomer = (this.props.selectedCustomer) ? this.props.selectedCustomer : '';
    if (selectedDay !== '') {
      this.setSelectedDay(selectedDay);
    }
    if (selectedRoute !== '') {
      this.setSelectedRoute(selectedRoute);
    }
    if (selectedCustomer !== '') {
      this.setSelectedCustomer(selectedCustomer);
    }
  }

  getRouteOptions() {
    const { routes } = this.state;
    const routeOptions = [];
    if (isLE) {
      _.forEach(this.props.allRoutesLEES, route => {
        routeOptions.push({
          label: route.RouteName,
          value: route.RouteName,
        })
      });
    } else {
      routes.map((route) => {
        routeOptions.push({
          value: route[0],
          label: route[0],
          email: route[1],
          driver: route[2],
        });
      });
    }
    return routeOptions;
  }

  getCustomerOptions() {
    const { allCustomers } = this.props;
    const customerOptions = [];
    allCustomers.map((customer) => {
      customerOptions.push({ value: customer, label: customer.Name });
    });
    return customerOptions;
  }

  getAllRouteOptions() {
    const { allRoutes } = this.props;
    let allRouteOptions = [];
    allRoutes.map((route) => {
      if (route.RouteNum !== this.state.selectedRoute.value) {
        allRouteOptions.push({ value: route.RouteNum, label: route.RouteNum });
      }
    });
    allRouteOptions = _.sortBy(allRouteOptions, key => key.value);
    return allRouteOptions;
  }

  getDriverOptions() {
    const { drivers } = this.state;
    const driverOptions = [];
    drivers.map((driver) => {
      driverOptions.push({ value: driver.id, label: driver.name });
    });
    return driverOptions;
  }

  handleFetchDrivers = () => {
    const handleSuccess = (drivers) => {
      this.setState({ drivers });
    };
    fetchAllDrivers(handleSuccess, () => {});
  }

  addCustomer() {
    if (!this.state.selectedCustomer.value || !this.state.selectedDay || !this.state.selectedRoute) {
      return;
    }
    const index = _.findIndex(this.state.sourceCustomers.rows, row => row.Name === this.state.selectedCustomer.value.Name);
    if (index !== -1) {
      alert('This customer is already on this route!');
      return;
    }
    const rows = [...this.state.sourceCustomers.rows];
    const newCustomer = { ...this.state.selectedCustomer.value, [this.state.sourceStopDay]: rows.length + 1 };
    rows.push(newCustomer);
    const sourceCustomers = { ...this.state.sourceCustomers, rows };
    this.setState({ sourceCustomers });
  }

  removeSourceRow(dependentValues) {
    let rows = [...this.state.sourceCustomers.rows];
    const stopNum = dependentValues[this.state.sourceStopDay];
    rows = rows.filter((row) => {
      const match = row[this.state.sourceStopDay] !== stopNum;
      return match;
    });
    rows.map((row, index) => {
      row[this.state.sourceStopDay] = index + 1;
    });
    const sourceCustomers = { ...this.state.sourceCustomers, rows };
    this.setState({ sourceCustomers });
  }

  removeDestRow(dependentValues) {
    let rows = [...this.state.destCustomers.rows];
    const stopNum = dependentValues[this.state.destStopDay];
    rows = rows.filter((row) => {
      const match = row[this.state.destStopDay] !== stopNum;
      return match;
    });
    rows.map((row, index) => {
      row[this.state.destStopDay] = index + 1;
    });
    const destCustomers = { ...this.state.destCustomers, rows };
    this.setState({ destCustomers });
  }

  moveLeftToRight(e) {
    if (this.state.cellSelected === 'Delete') {
      return;
    }
    const invalid = _.findIndex(this.state.destCustomers.rows, row => row.Name === e.Name);
    if (invalid !== -1) {
      alert('This customer is already on the route!');
      return;
    }
    if (!this.state.selectedAllRoutes) {
      alert('Please select a new route!');
      return;
    }
    if (!this.state.selectedAllRoutes) {
      alert('Please select a new route!');
      return;
    }
    let leftRows = this.state.sourceCustomers.rows;
    const rightRows = this.state.destCustomers.rows;
    const stopNum = e[this.state.sourceStopDay];
    leftRows = leftRows.filter((row) => {
      const match = row[this.state.sourceStopDay] !== stopNum;
      return match;
    });
    leftRows.map((row, index) => {
      row[this.state.sourceStopDay] = index + 1;
    });
    const newStopNumber = rightRows.length + 1;
    const newCustomer = { ...e, [this.state.destStopDay]: newStopNumber, [this.state.destRouteDay]: this.state.selectedAllRoutes.value };
    rightRows.push(newCustomer);
    const sourceCustomers = { ...this.state.sourceCustomers, rows: leftRows };
    const destCustomers = { ...this.state.destCustomers, rows: rightRows };
    this.setState({ sourceCustomers, destCustomers });
  }

  moveRightToLeft(e) {
    const invalid = _.findIndex(this.state.sourceCustomers.rows, row => row.Name === e.Name);
    if (invalid !== -1) {
      alert('This customer is already on the route!');
      return;
    }
    const leftRows = this.state.sourceCustomers.rows;
    let rightRows = this.state.destCustomers.rows;
    const stopNum = e[this.state.destStopDay];
    rightRows = rightRows.filter((row) => {
      const match = row[this.state.destStopDay] !== stopNum;
      return match;
    });
    rightRows.map((row, index) => {
      row[this.state.destStopDay] = index + 1;
    });
    const newStopNumber = leftRows.length + 1;
    const newCustomer = { ...e, [this.state.sourceStopDay]: newStopNumber, [this.state.sourceRouteDay]: this.state.selectedRoute.value };
    leftRows.push(newCustomer);
    const sourceCustomers = { ...this.state.sourceCustomers, rows: leftRows };
    const destCustomers = { ...this.state.destCustomers, rows: rightRows };
    this.setState({ sourceCustomers, destCustomers });
  }

  saveRouteEdits() {
    const {
      sourceCustomers,
      destCustomers,
      sourceStopDay,
      destStopDay,
      selectedRoute,
      selectedAllRoutes,
      email,
      selectedDriver,
      selectedDay,
    } = this.state;
    if (!selectedRoute) {
      alert('Select a route!');
      return;
    }
    if (!selectedAllRoutes && !destCustomers) {
      alert('Select a new route!');
      return;
    }
    let driverId = '';
    if (selectedRoute) {
      driverId = selectedDriver.value;
    }
    // if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
    //   alert('Email is not valid,Please input again.');
    //   return;
    // }
    const oldRoute = {
      RouteNum: '',
      Stops: [],
      Day: selectedDay,
    };
    const newRoute = {
      RouteNum: '',
      Stops: [],
    };
    oldRoute.RouteNum = selectedRoute.value;
    newRoute.RouteNum = (selectedAllRoutes) ? selectedAllRoutes.value : null;
    sourceCustomers.rows.map((row) => {
      oldRoute.Stops.push({ StopNum: row[sourceStopDay], Customer: row.Customer_id });
    });
    if (selectedAllRoutes !== '') {
      destCustomers.rows.map((row) => {
        newRoute.Stops.push({ StopNum: row[destStopDay], Customer: row.Customer_id });
      });
    }
    this.props.action(oldRoute, newRoute, email, driverId);
  }

  renderSourceGrid() {
    const getRows = () => Data.Selectors.getRows(this.state.sourceCustomers);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const isDraggedRowSelected = (selectedRows, rowDragSource) => {
      if (selectedRows && selectedRows.length > 0) {
        const key = this.props.rowKey;
        return selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0;
      }
      return false;
    };

    const reorderRows = (e) => {
      const selectedRows = Selectors.getSelectedRowsByKey({ rowKey: this.props.rowKey, selectedKeys: [], rows: this.state.sourceCustomers.rows });
      const draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
      const undraggedRows = this.state.sourceCustomers.rows.filter(r => draggedRows.indexOf(r) === -1);
      const args = [e.rowTarget.idx, 0].concat(draggedRows);
      Array.prototype.splice.apply(undraggedRows, args);
      undraggedRows.map((row, index) => {
        row[this.state.sourceStopDay] = index + 1;
      });
      const sourceCustomers = { ...this.state.sourceCustomers, rows: undraggedRows };
      this.setState({ sourceCustomers });
    };

    const onCellSelected = (coordinates) => {
      if (coordinates.idx === 1) {
        this.setState({ cellSelected: 'Delete' });
      } else {
        this.setState({ cellSelected: 'NotDelete' });
      }
    };

    const DeleteFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={() => {
                this.props.remove(this.props.dependentValues);
              }}
            >X
            </Button>
          </span>
        );
      },
    });

    const columns = [
      {
        name: <Translate value="del" />,
        width: 50,
        formatter: <DeleteFormatter remove={this.removeSourceRow} />,
        getRowMetaData: row => row,
      },
      {
        key: 'Name',
        name: <Translate value="customer_name" />,
        resizable: true,
        editable: false,
      },
      {
        key: 'CustomerNum',
        name: <Translate value="customer_number" />,
        resizable: true,
        editable: false,
      },
      // {
      //   key: `${this.state.sourceStopDay}`,
      //   name: <Translate value="stop_number" />,
      //   resizable: true,
      //   editable: false,
      // },
    ];

    return (
      <Row>
        <Col sm={12}>
          <DraggableContainer style={{ maxWidth: '100%' }}>
            <ReactDataGrid
              columns={columns}
              rowHeight={25}
              minHeight={490}
              enableRowSelect="single"
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowActionsCell={RowActionsCell}
              onCellSelected={onCellSelected}
              rowRenderer={<RowRenderer onRowDrop={reorderRows} onDoubleClick={this.moveLeftToRight} />}
            />
          </DraggableContainer>
        </Col>
      </Row>
    );
  }

  renderDestGrid() {
    const getRows = () => Data.Selectors.getRows(this.state.destCustomers);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const isDraggedRowSelected = (selectedRows, rowDragSource) => {
      if (selectedRows && selectedRows.length > 0) {
        const key = this.props.rowKey;
        return selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0;
      }
      return false;
    };

    const reorderRows = (e) => {
      const selectedRows = Selectors.getSelectedRowsByKey({ rowKey: this.props.rowKey, selectedKeys: [], rows: this.state.destCustomers.rows });
      const draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
      const undraggedRows = this.state.destCustomers.rows.filter(r => draggedRows.indexOf(r) === -1);
      const args = [e.rowTarget.idx, 0].concat(draggedRows);
      Array.prototype.splice.apply(undraggedRows, args);
      undraggedRows.map((row, index) => {
        row[this.state.destStopDay] = index + 1;
      });
      const destCustomers = { ...this.state.destCustomers, rows: undraggedRows };
      this.setState({ destCustomers });
    };

    const DeleteFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={() => {
                this.props.remove(this.props.dependentValues);
              }}
            >X
            </Button>
          </span>
        );
      },
    });

    const columns = [
      {
        name: <Translate value="del" />,
        width: 50,
        formatter: <DeleteFormatter remove={this.removeDestRow} />,
        getRowMetaData: row => row,
      },
      {
        key: 'Name',
        name: <Translate value="customer_name" />,
        resizable: true,
        editable: false,
      },
      {
        key: 'CustomerNum',
        name: <Translate value="customer_number" />,
        resizable: true,
        editable: false,
      },
      // {
      //   key: `${this.state.destStopDay}`,
      //   name: <Translate value="stop_number" />,
      //   resizable: true,
      //   editable: false,
      // },
    ];

    return (
      <Row>
        <Col sm={12}>
          <DraggableContainer style={{ maxWidth: '100%' }}>
            <ReactDataGrid
              columns={columns}
              rowHeight={25}
              minHeight={490}
              enableRowSelect="single"
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowActionsCell={RowActionsCell}
              rowRenderer={<RowRenderer onRowDrop={reorderRows} onDoubleClick={this.moveRightToLeft} />}
            />
          </DraggableContainer>
        </Col>
      </Row>
    );
  }

  render() {
    const routeOptions = this.getRouteOptions();
    const dayOptions = EditRouteModal.getDayOptions();
    const customerOptions = this.getCustomerOptions();
    const driverOptions = this.getDriverOptions();
    const allRouteOptions = this.getAllRouteOptions();
    return (
      <div id="edit-route-modal">
        <Row>
          <Col xs={10}>
            <div className="selection">
              {
                GenericSelection({
                  translation: <Translate value="select_day" />,
                  options: dayOptions,
                  value: this.state.selectedDay,
                  setSelected: this.setSelectedDay,
                })
              }
              {
                GenericSelection({
                  translation: <Translate value="select_route" />,
                  options: routeOptions,
                  value: this.state.selectedRoute,
                  setSelected: this.setSelectedRoute,
                })
              }
              {
                GenericSelection({
                  translation: <Translate value="select_driver" />,
                  options: driverOptions,
                  value: this.state.selectedDriver,
                  setSelected: this.setSelectedDriver,
                })
              }
              <div>
                <label htmlFor=""><Translate value="phone" /></label>
                <input
                  style={{
                    border: '1px solid black',
                    marginLeft: '10px',
                    borderRadius: '4px',
                    padding: '3px 5px',
                    height: '25px',
                  }}
                  type="text"
                  value={this.state.email}
                  onChange={(e) => { this.setState({ email: e.target.value }); }}
                />
              </div>
            </div>
          </Col>
          <Col xs={2}>
            <div className="save-buttons">
              <ButtonToolbar>
                <SpinnerButton
                  bsStyle="success"
                  onClick={() => {
                    this.saveRouteEdits();
                  }}
                  loading={this.props.savingRouteEdits}
                  icon="fa-save"
                  translation={<Translate value="save" />}
                  disabled={this.props.savingRouteEdits}
                />
              </ButtonToolbar>
            </div>
          </Col>
          <Col xs={12}>
            <div className="horizontal-divider" />
          </Col>
          <Col xs={12}>
            <div className="selection" id="customer-selection">
              {
                GenericSelection({
                  translation: <Translate value="select_customer" />,
                  options: customerOptions,
                  value: this.state.selectedCustomer,
                  setSelected: this.setSelectedCustomer,
                })
              }
            </div>
            <div className="add-button">
              <Button
                bsStyle="primary"
                onClick={() => { this.addCustomer(); }}
              >
                <em className="fa fa-plus" />
              </Button>
            </div>
            <div className="selection" id="new-route-selection">
              {
                GenericSelection({
                  translation: <Translate value="select_new_route" />,
                  options: allRouteOptions,
                  value: this.state.selectedAllRoutes,
                  setSelected: this.setSelectedAllRoutes,
                })
              }
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            {this.renderSourceGrid()}
          </Col>
          <Col xs={6}>
            {this.renderDestGrid()}
          </Col>
        </Row>
      </div>
    );
  }
}

EditRouteModal.defaultProps = {
  allRoutes: [],
  customersWithStops: {},
  allCustomers: [],
  dependentValues: {},
  remove: null,
  rowKey: 'Name',
  savingRouteEdits: false,
  selectedDay: null,
  selectedRoute: null,
  selectedCustomer: null,
};

EditRouteModal.propTypes = {
  allRoutes: PropTypes.arrayOf(PropTypes.object),
  customersWithStops: PropTypes.shape({
    filteredRows: PropTypes.arrayOf(PropTypes.object),
    rows: PropTypes.arrayOf(PropTypes.object),
    selectedRow: PropTypes.object,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
  }),
  allCustomers: PropTypes.arrayOf(PropTypes.object),
  dependentValues: PropTypes.shape({}),
  remove: PropTypes.func,
  rowKey: PropTypes.string,
  savingRouteEdits: PropTypes.bool,
  action: PropTypes.func.isRequired,
  selectedDay: PropTypes.string,
  selectedRoute: PropTypes.string,
  selectedCustomer: PropTypes.string,
};

export default EditRouteModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/EditRouteModal.jsx